var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-container",attrs:{"id":_vm.info.id}},[(_vm.info.background)?_c('img',{staticClass:"bg",attrs:{"src":_vm.info.background +
      '&imageMogr2/thumbnail/2000x2000/format/' +
      _vm.$pic_type +
      '/interlace/1',"alt":""}}):_c('div',{staticClass:"default-box"}),(_vm.isEditMode)?[_c('div',[_c('section',{staticClass:"wrapper",style:({
               width: _vm.info.width + '%',
               height: _vm.info.height + '%',
               top: _vm.info.style.top + '%',
               left: _vm.info.style.left + '%',
               position: 'absolute'
             })},[_c('video',{staticClass:"video-js vjs-big-play-centered vjs-fluid video editMode",attrs:{"id":_vm.id,"preload":"auto","webkit-playsinline":"","playsinline":"","x5-playsinline":"","x-webkit-airplay":"allow","poster":_vm.info.poster +
          '&imageMogr2/thumbnail/2000x2000/format/' +
          _vm.$pic_type +
          '/interlace/1'}},[_c('source',{attrs:{"src":_vm.info.src}})])])])]:[_c('section',{staticClass:"wrapper",style:({
               width: _vm.info.width + '%',
               height: _vm.info.height + '%',
               top: _vm.info.style.top + '%',
               left: _vm.info.style.left + '%',
               position: 'absolute'
             })},[_c('video',{staticClass:"video-js vjs-big-play-centered video",attrs:{"id":_vm.id,"preload":"auto","webkit-playsinline":"","playsinline":"","x5-playsinline":"","x-webkit-airplay":"allow","poster":_vm.info.poster +
          '&imageMogr2/thumbnail/2000x2000/format/' +
          _vm.$pic_type +
          '/interlace/1'}},[_c('source',{attrs:{"src":_vm.info.src}})])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }